import { ref, watch, computed, onMounted } from "@vue/composition-api";
import store from "@/store";
import { title } from "@core/utils/filter";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useIssuesList() {
  // Use toast
  const toast = useToast();

  const refIssueListTable = ref(null);

  //fileter
  const supplierFilter = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: "issue_date", label: "日期", sortable: true },
    {
      key: "issue_number",
      label: "出倉編號",
      sortable: true,
      stickyColumn: true,
    } /* 
    {
      key: "supplier.name",
      label: "供應商",
    }, */,
    { key: "remark", label: "備註" },
    { key: "issue_products", label: "產品" },
    { key: "actions", label: "操作" },
  ];

  const perPage = ref(50);
  const totalIssues = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("issue_date");
  const isSortDirDesc = ref(true);

  const dataMeta = computed(() => {
    const localItemsCount = refIssueListTable.value
      ? refIssueListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalIssues.value,
    };
  });

  const refetchData = () => {
    refIssueListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, supplierFilter], () => {
    refetchData();
  });

  const fetchIssues = (ctx, callback) => {
    store
      .dispatch("app-issue/fetchIssues", {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        supplier_id: supplierFilter.value,
      })
      .then((response) => {
        const { stock_issues, total } = response.data;
        callback(stock_issues);
        totalIssues.value = total;
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching issues list",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };

  const supplierOptions = ref([]);

  onMounted(() => {
    store
      .dispatch("app/fetchOptionList", {
        supplier: true,
      })
      .then((response) => {
        supplierOptions.value = response.data.suppliers;
      })
      .catch((error) => {
        console.log(error);
      });
  });

  return {
    fetchIssues,
    tableColumns,
    perPage,
    currentPage,
    totalIssues,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refIssueListTable,
    ability,
    refetchData,
    supplierFilter,
    supplierOptions,
    // Extra Filters
  };
}
